import { useState } from "react";
import { Link } from "react-router-dom";
import { api, getApiErrorMessage } from "@/lib/api";
import { ArrowLeft, Mail, ArrowRight } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (err) { setError(getApiErrorMessage(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F5F2] px-6 py-10">
      <div className="w-full max-w-md bg-white border border-[#E8E6E1] rounded-3xl p-8 lg:p-10 shadow-[0_8px_30px_rgb(0,0,0,0.04)]" data-testid="forgot-password-page">
        <Link to="/login" className="inline-flex items-center gap-1.5 text-xs text-[#5C6660] hover:text-[#2A4D3E] mb-6">
          <ArrowLeft size={14} /> Back to sign in
        </Link>
        <div className="text-xs uppercase tracking-[0.2em] text-[#8E9992] font-semibold mb-2">Reset</div>
        <h1 className="font-heading text-3xl font-semibold text-[#2A332C]">Forgot password?</h1>
        <p className="text-sm text-[#5C6660] mt-2 mb-6">Enter your email and we'll send a secure reset link.</p>

        {sent ? (
          <div className="text-center py-6" data-testid="forgot-sent">
            <div className="w-12 h-12 rounded-full bg-[#E6F0EB] flex items-center justify-center mx-auto mb-4">
              <Mail size={20} className="text-[#2A4D3E]" />
            </div>
            <div className="font-medium text-[#2A332C]">Check your email</div>
            <p className="text-sm text-[#5C6660] mt-2">If an account exists for <strong>{email}</strong>, we've sent a password reset link. The link expires in 1 hour.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-[#5C6660] mb-1.5">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="forgot-email"
                className="w-full border border-[#E8E6E1] rounded-xl px-4 py-3 bg-[#FDFCFB] focus:outline-none focus:border-[#2A4D3E] focus:ring-1 focus:ring-[#2A4D3E]" />
            </div>
            {error && <div className="text-sm text-[#C0392B] bg-[#FDEDEC] border border-[#F5D6D2] rounded-xl px-4 py-3">{error}</div>}
            <button type="submit" disabled={loading} data-testid="forgot-submit"
              className="w-full bg-[#2A4D3E] text-white rounded-full px-6 py-3 font-medium hover:bg-[#1E3B2F] disabled:opacity-50 flex items-center justify-center gap-2 group">
              {loading ? "Sending…" : (<>Send reset link <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" /></>)}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
